(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-november-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fluer-offer-slider')) {
    customElements.define('fluer-offer-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.slides = [...this.querySelectorAll('[data-offer-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-index]')];
        this.current = 0;
        this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        if (this.slides.length < 2) return;
        this.querySelector('.fluer-offers__controls').hidden = false;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {this.pause(); this.show(this.current + Number(button.dataset.step));}, options));
        this.dots.forEach(button => button.addEventListener('click', () => {this.pause(); this.show(Number(button.dataset.slideIndex));}, options));
        this.querySelector('[data-toggle]')?.addEventListener('click', () => {this.paused = !this.paused; this.update();}, options);
        this.addEventListener('mouseenter', () => {this.hovered = true; this.update();}, options);
        this.addEventListener('mouseleave', () => {this.hovered = false; this.update();}, options);
        this.addEventListener('focusin', () => {this.focused = true; this.update();}, options);
        this.addEventListener('focusout', event => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.update();}}, options);
        this.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); this.pause(); this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));}}, options);
        this.addEventListener('shopify:block:select', event => {const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (index >= 0) {this.pause(); this.show(index);}}, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.update();
      }
      show(index) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {slide.hidden = i !== this.current;});
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      }
      pause() {this.paused = true; this.update();}
      update() {
        clearInterval(this.timer);
        const toggle = this.querySelector('[data-toggle]');
        if (toggle) toggle.textContent = this.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        this.querySelector('.fluer-offers__slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
        if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 8000);
      }
      disconnectedCallback() {clearInterval(this.timer); this.abort?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluer-blog-highlights"] && !Shopify.designMode) return;
  try {
    
(() => {
  const queue = [];
  const requests = new Map();
  let active = 0;

  const readCover = async (url) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Category cover unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = html.querySelector('template[data-na-latest-cover]');
      return template ? template.cloneNode(true) : null;
    } finally {
      clearTimeout(timeout);
    }
  };

  const update = async (card) => {
    const url = new URL(card.dataset.naCategoryCoverUrl, window.location.origin);
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('section_id', 'na-category-cover');
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    card.dataset.naCoverStatus = 'loading';
    try {
      const key = url.href;
      if (!requests.has(key)) requests.set(key, readCover(key));
      const template = await requests.get(key);
      card.dataset.naCoverArticle = template?.dataset.article || '';
      const image = template?.content.querySelector('img');
      if (!image) {
        card.dataset.naCoverStatus = 'fallback';
        return;
      }
      const replacement = image.cloneNode(true);
      const previous = card.querySelector('img');
      replacement.addEventListener('error', () => {
        if (previous) replacement.replaceWith(previous);
        else replacement.remove();
        card.dataset.naCoverStatus = 'fallback';
      }, { once: true });
      if (previous) previous.replaceWith(replacement);
      else card.prepend(replacement);
      card.dataset.naCoverStatus = 'ready';
    } catch {
      card.dataset.naCoverStatus = 'fallback';
    }
  };

  const drain = () => {
    while (active < 2 && queue.length) {
      const card = queue.shift();
      active += 1;
      update(card).finally(() => {
        active -= 1;
        drain();
      });
    }
  };

  const enqueue = (card) => {
    queue.push(card);
    drain();
  };

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        enqueue(entry.target);
      }
    });
  }, { rootMargin: '300px' }) : null;

  const initialize = (root) => {
    root.querySelectorAll('[data-na-category-cover-url]').forEach((card) => {
      if (card.dataset.naCoverStatus) return;
      card.dataset.naCoverStatus = 'waiting';
      if (observer) observer.observe(card);
      else enqueue(card);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluer-offer-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fluer-offer-slider')) {
    customElements.define('fluer-offer-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.slides = [...this.querySelectorAll('[data-offer-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-index]')];
        this.current = 0;
        this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        if (this.slides.length < 2) return;
        this.querySelector('.fluer-offers__controls').hidden = false;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {this.pause(); this.show(this.current + Number(button.dataset.step));}, options));
        this.dots.forEach(button => button.addEventListener('click', () => {this.pause(); this.show(Number(button.dataset.slideIndex));}, options));
        this.querySelector('[data-toggle]')?.addEventListener('click', () => {this.paused = !this.paused; this.update();}, options);
        this.addEventListener('mouseenter', () => {this.hovered = true; this.update();}, options);
        this.addEventListener('mouseleave', () => {this.hovered = false; this.update();}, options);
        this.addEventListener('focusin', () => {this.focused = true; this.update();}, options);
        this.addEventListener('focusout', event => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.update();}}, options);
        this.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); this.pause(); this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));}}, options);
        this.addEventListener('shopify:block:select', event => {const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (index >= 0) {this.pause(); this.show(index);}}, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.update();
      }
      show(index) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {slide.hidden = i !== this.current;});
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      }
      pause() {this.paused = true; this.update();}
      update() {
        clearInterval(this.timer);
        const toggle = this.querySelector('[data-toggle]');
        if (toggle) toggle.textContent = this.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        this.querySelector('.fluer-offers__slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
        if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 8000);
      }
      disconnectedCallback() {clearInterval(this.timer); this.abort?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
